import { useEffect, useRef, useState } from 'react';

import Button from '../Button/Button';
import { EditIcon } from '../Icon/Icon';
import { EditInputWrapper, InputStyled } from './EditInput.styled';

type EditInputPropsT = {
  label: React.ReactNode;
  min?: number;
  onChange: (val: number) => void;
};

const EditInput: React.FC<EditInputPropsT> = ({ label, min = 0, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isEdit, setIsEdit] = useState(false);
  const [inputValue, setInputValue] = useState<number | string>(min);

  const handleOnClickEdit = () => {
    setIsEdit(true);
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;

    if (regex.test(input)) {
      setInputValue(input);
      onChange(Number(input));
    }
  };

  const handleOnBlur = () => {
    if (min && +inputValue < min) {
      setInputValue(min);
      onChange(min);
    } else {
      setInputValue(+inputValue);
      onChange(+inputValue);
    }

    setIsEdit(false);
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [isEdit]);

  useEffect(() => {
    setInputValue(min);
  }, [min]);

  return (
    <EditInputWrapper>
      {!isEdit ? (
        <>
          <Button modifier="inline" onClick={handleOnClickEdit}>
            <EditIcon />
          </Button>

          {label}
        </>
      ) : (
        <InputStyled
          type="text"
          ref={inputRef}
          value={inputValue}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
        />
      )}
    </EditInputWrapper>
  );
};

export default EditInput;
